import React, { useState } from "react";
import { faKey } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/base/Button";
import Section from "components/base/Section";
import ChangePasswordModal from "components/modals/ChangePasswordModal";
import SellerProfileManager from "components/modules/seller/SellerProfileManager";
import { useAuth } from "providers/AuthProvider";

const SellerProfile = () => {
  const { seller } = useAuth();
  const [showModal, setShowModal] = useState(false);

  if (!seller) return null;

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <div className="pt-5">
      <Section small className="py-0">
        {/* Password Button */}
        <div className="text-end mb-4">
          <Button 
            variant="outline-primary" 
            className="me-2"
            onClick={handleShowModal}
          >
            <FontAwesomeIcon icon={faKey} className="me-2" />
            Change Password
          </Button>
        </div>

        {/* Integrated Profile Manager Component */}
        <SellerProfileManager />
      </Section>

      <ChangePasswordModal show={showModal} handleClose={handleCloseModal} />
    </div>
  );
};

export default SellerProfile;
